// autogenerated
import {AthenaeumConstants, ServiceProvider} from "@reapptor-apps/reapptor-toolkit";
import {ETagRequest} from "@reapptor-apps/reapptor-react-common";

export default class GetCruisePackageAvailabilityRequest extends ETagRequest {

    public readonly isGetCruisePackageAvailabilityRequest: true = true;

    public static is(from?: object | null): boolean {
        // noinspection PointlessBooleanExpressionJS
        return (from != null) && ((from instanceof GetCruisePackageAvailabilityRequest) || ((from as any).isGetCruisePackageAvailabilityRequest === true));
    }

    public static as(from?: object | null): GetCruisePackageAvailabilityRequest | null {
        return (GetCruisePackageAvailabilityRequest.is(from)) ? from as GetCruisePackageAvailabilityRequest : null;
    }

    // #region Placeholder

    // Put your code here (function, properties, ect...)

    // #endregion
}

ServiceProvider.addType(GetCruisePackageAvailabilityRequest, "GetCruisePackageAvailabilityRequest");